import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M9 11a2 2 0 100-4 2 2 0 000 4zM15.375 11a2 2 0 100-4 2 2 0 000 4zM9 17.375a2 2 0 100-4 2 2 0 000 4zM15.375 17.375a2 2 0 100-4 2 2 0 000 4z"
      />
    </svg>
  );
}

export default Icon;
